import { getUniversalHelpers } from "../../helpers";
import { Org, OrgId, OrgSettings } from "@ollie-sports/models";

export async function orgSettings__client__getOrgSettings(p: { orgId: OrgId }): Promise<OrgSettings | null> {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  return await h.OrgSettings.getDoc(p.orgId);
}

// i18n certified - complete
